import { render, staticRenderFns } from "./sidebar-btn.vue?vue&type=template&id=7d419555&scoped=true"
import script from "./sidebar-btn.vue?vue&type=script&lang=js"
export * from "./sidebar-btn.vue?vue&type=script&lang=js"
import style0 from "./sidebar-btn.vue?vue&type=style&index=0&id=7d419555&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d419555",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\mrzhj\\Desktop\\ff\\frontent\\takeout\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d419555')) {
      api.createRecord('7d419555', component.options)
    } else {
      api.reload('7d419555', component.options)
    }
    module.hot.accept("./sidebar-btn.vue?vue&type=template&id=7d419555&scoped=true", function () {
      api.rerender('7d419555', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/public/sidebar-btn.vue"
export default component.exports